import './Header.scss';
import { IoIosArrowBack } from "react-icons/io"
import UserProfile from './UserProfile';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getLayoutJsonByLayoutCode } from '../../../core/actionCreators/lmsActionCreator';
import { toast } from 'react-hot-toast';
import { clearCacheByLayoutService } from '../../../core/services/lmsServices';

const ComponentListHeader = (props: any) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { layoutId, layoutCode, layoutName, componentCount,
        device, setAddComponentPopup, setJsonViewPopup, setCloneLayoutPopup } = props

    const selectAndCopyComponentClickHandler = () => {
        navigate(`/layout/${layoutId}/component`)
    }

    const previewLayoutJsonClickHandler = () => {
        dispatch(getLayoutJsonByLayoutCode(`layoutCode=${layoutCode}`, null))
        setJsonViewPopup(true)
    }

    const clearCacheClickHandler = () => {
        let res = window.confirm("Are you sure want to clear cache?")
        if (res) {
            clearCacheByLayoutService(`layoutCode=${layoutCode}`).then((r) => {
                toast.success("Cleared successfully.")
            }).catch((err) => {
                console.log(err)
            })
        }
    }

    return (<>

        <div className="header">
            <div className="header-inner">
                <div className="main-header flex items-center p-[15px]">
                    <div className="header-left">
                    </div>
                    <UserProfile />
                </div>
                <div className="haderVarient2 items-center flex justify-between p-[15px]">
                    <div className="pagename-n-input flex items-center ">
                        <Link to={`/layout`}><IoIosArrowBack /></Link>

                        <div className="pagename-sec">
                            <h2 className='font-bold'>{layoutName}
                            </h2>
                            <p className='onhoverName'>{layoutName}</p>
                            <p className='text-xs p-subname'>
                                {device} | {layoutCode}
                                {componentCount ? ` | ${componentCount} components` : ""}
                            </p>
                        </div>
                    </div>
                    <div className="right-buttons items-center flex justify-end">
                        <button onClick={previewLayoutJsonClickHandler} className='ghost-btn py-2 px-4 font-semibold rounded'>
                            Layout JSON
                            <span className="btn-tip">Preview the JSON this layout serves to the site</span>
                        </button>
                        <button onClick={selectAndCopyComponentClickHandler} className='ghost-btn py-2 px-4 font-semibold rounded'>
                            Select / Copy Component
                            <span className="btn-tip">Search existing components and copy them into this layout</span>
                        </button>
                        <button onClick={clearCacheClickHandler} className='ghost-btn py-2 px-4 font-semibold rounded'>
                            Clear Cache
                            <span className="btn-tip">Clear the cached response for this layout so changes go live</span>
                        </button>
                        <button onClick={() => setCloneLayoutPopup(true)} className='ghost-btn py-2 px-4 font-semibold rounded'>
                            Clone Layout
                            <span className="btn-tip">Copy this layout, its components and elements into a new layout</span>
                        </button>
                        <button onClick={() => setAddComponentPopup(true)} className='primary-btn py-2 px-4 bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75'>
                            Add Component
                            <span className="btn-tip">Create a new component and add it to this layout</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ComponentListHeader
